import {Component, Inject} from '@angular/core';
import {PDFViewerComponent} from './pdfviewer.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {DokumentDataService} from '../services/dokument-data.service';
import {MessageBoxService} from '../services/message-box.service';
import {ObjektDataService} from '../services/objekt-data.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UserAuthenticationService} from '../services/user-authentication.service';
import {AnnotationStorageServiceService} from '../services/annotation-storage-service.service';
import {HelperService} from '../services/helper.service';
import {DokumentModels} from '../models/dokument-models';
import {DeviceDetectionService} from '../services/device-detection-service';
import {LocalStorageService} from '../local-storage.service';
import {DocumentManagementService} from '../services/document-management.service';
import {Platform} from '@angular/cdk/platform';

@Component({
    selector: 'app-pdfviewer', templateUrl: './pdfviewer.component.html', styleUrls: ['./pdfviewer.component.scss'],
})
export class PDFViewerDialogComponent extends PDFViewerComponent {
    constructor(public localStorageService: LocalStorageService,
                public deviceDetectionService: DeviceDetectionService,
                public dialog: MatDialog,
                private dialogRef: MatDialogRef<PDFViewerDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: { isDialogMode: boolean },
                docService: DokumentDataService,
                svcMessageBox: MessageBoxService,
                svcObjekte: ObjektDataService,
                route: ActivatedRoute,
                userAuthService: UserAuthenticationService,
                router: Router,
                annotationStorage: AnnotationStorageServiceService,
                helperService: HelperService,
                documentManagementService: DocumentManagementService,
                platform: Platform) {
        super(localStorageService, deviceDetectionService, dialog, docService, svcMessageBox, svcObjekte, route, userAuthService, router, annotationStorage, helperService, documentManagementService, platform);
    }

    override async close(): Promise<void> {
        await this.closeDialog();
        await this.pdfuiInstance.close();
        const dokuData = this.docService.getDocumentInfo();

        if (!this.data || !this.data.isDialogMode) {
            this.helperService.setPageRefreshURL('internalRouting').then(() => {
                if (dokuData && (dokuData.dokumentQuelle === DokumentModels.DokumentSource.SA_DBChecklisten || dokuData.dokumentQuelle === DokumentModels.DokumentSource.SA_DBRapporte || dokuData.dokumentQuelle === DokumentModels.DokumentSource.SA_DBDokumente)) {
                    this.router.navigate([this.saUrl, dokuData.objectID]);
                } else {
                    const currObjectID = this.svcObjekte.getCurrentObjectID();
                    if (currObjectID) {
                        this.router.navigate([this.objektUrl, currObjectID]);
                    }
                }
            });
        } else {
            this.dialogRef.close();
        }
    }
}
